import { ListService } from '@/service/list/ListService';
import { StaffSeed } from '@/API';

/**
 * Service for fetching bought lists with pagination, filtering, and sorting.
 */
export class StaffSeedService extends ListService<StaffSeed> {}
